var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var recordToArray = function (record, keyFieldName) {
  if (keyFieldName === void 0) {
    keyFieldName = 'name';
  }
  return Object.keys(record).map(function (key) {
    var _a;
    return __assign((_a = {}, _a[keyFieldName] = key, _a), record[key]);
  });
};
export function recordToArrayWithName(record) {
  return recordToArray(record, 'name');
}